import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PIconModule } from '@panaya/ui/p-icon';

/** A local busy pill: the design system's `p-snackbar` is legacy and not publishable. */
@Component({
    standalone: true,
    selector: 'p-ai-chat-canvas-busy-pill',
    imports: [PIconModule],
    templateUrl: './canvas-busy-pill.component.html',
    styleUrls: ['./canvas-busy-pill.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CanvasBusyPillComponent {}
